export default __webpack_public_path__ + "static/media/Protect_Valkyrie.e43528c3.svg";